import React, { useState } from 'react';
// import howItWorksImage from '../assets/images/Smart_Acharya_work.PNG';

const FAQs = () => {
    const [openIndex, setOpenIndex] = useState(null);
    // console.log(howItWorksImage,"howItWorksImage --->");
    const faqs = [
        {
            question: "What is Artificial Intelligence (AI)?",
            answer: "Generative AI is a type of artificial intelligence (AI) that can create new content based on patterns it learns from existing data."
        },
        {
            question: "What is Smart Acharya?",
            answer: "Smart Acharya is an EdTech platform that leverages the power of AI and puts it into educators and students hands to help them use it productively and responsibly in their respective work. Designed for Educators, Schools and Institutions, our solution eliminates manual exam creation, reduces grading time, and provides actionable insights to enhance learning outcomes.<br/><br/>Want to know more? Please check get in touch with us for a consultation."
        },
        {
            question: "Why did you build Smart Acharya? Why Artificial Intelligence (AI) in education?",
            answer: "Smart Acharya was built to embrace responsible AI for students to personalise learning, engage them in creative ways, and build their AI literacy skills. Smart Acharya empowers students with the tools they need to explore AI creatively, receive tailored feedback, and access learning support to ensure equity for all learners—while maintaining full control over data privacy, moderation, and integration.<br/><br/>Register your interest for free today."
        },
        {
            question: "How does Smart Acharya’s AI work? Which AI powers the platform and what Large Language Models (LLM’s) do you use?",
            answer: "We ensure that each tool on the platform is accompanied by the best AI model to generate the strongest outputs. The platform can be powered by various proprietary models. Whilst, we have trained our own Local models, we believe that it will result in better outcomes for our users. Based on our testing, we are theoretically confident that our local model, is in par with some of the proprietary models. Constant experimentation is conducted to pair tools with different models to determine the most optimal AI model for specific tasks. We know that AI technology moves fast and therefore, it’s important that we’re able to flex between models to produce the best possible experience for educators. This iterative process ensures that the platform consistently delivers the highest quality responses to its users."
        },
        // {
        //     question: "How does Smart Acharya work?",
        //     answer: `
        //         <div class="flex flex-col items-start space-y-3 max-w-full">
        //             <div class="flex flex-wrap items-center gap-x-2 gap-y-1">
        //                 <span class="font-medium">Educator focussed guidance</span>
        //                 <span class="text-lg">↘</span>
        //                 <span class="font-bold text-[#8c5021] mx-1">Smart Acharya</span>
        //                 <span class="text-lg">→</span>
        //                 <span class="font-medium">The Best possible Output</span>
        //             </div>
        //             <div class="flex flex-wrap items-center gap-x-2">
        //                 <span class="font-medium">High Quality Output Examples</span>
        //                 <span class="text-lg">→</span>
        //                 <span class="font-bold text-[#8c5021] mx-1">Smart Acharya</span>
        //             </div>
        //             <div class="flex flex-wrap items-center gap-x-2">
        //                 <span class="font-medium">Information provided by you</span>
        //                 <span class="text-lg">↗</span>
        //                 <span class="font-bold text-[#8c5021] mx-1">Smart Acharya</span>
        //             </div>
        //             <div class="flex flex-wrap items-center gap-x-2">
        //                 <span class="font-medium">The best AI Model for Students</span>
        //                 <span class="text-lg">↗</span>
        //                 <span class="font-bold text-[#8c5021] mx-1">Smart Acharya</span>
        //             </div>
        //         </div>
        //     `
        // }
         {
            question: "How does Smart Acharya work?",
            answer: `<img src="/smart_acharya_work.png" alt="How Smart Acharya works" class="max-w-full h-auto mx-auto" />`
        }
        ,
        {
            question: "How does Smart Acharya personalise the learning experience?",
            answer: "Smart Acharya uses advanced AI algorithms to analyse the learning patterns, strengths, and areas for improvement. The platform adapts content difficulty, suggests relevant materials, and provides customised practice exercises based on the unique learning profile."
        },
        {
            question: "What are the best practices for using Smart Acharya appropriately?",
            answer: "Smart Acharya is proactive with sharing best practices for ethical and responsible usage of AI. AI is a tool, not a replacement for thinking: Students should see AI generated content as something that can help assist them, but not the final solution. AI might occasionally produce biased or incorrect content. Students should always double check important information. Student’s shouldn’t include personal details like names or addresses. We strive to promptly remove any accidentally submitted information."
        },
        {
            question: "What are Smart Acharya’s Terms and Conditions? How do you protect privacy?",
            answer: "We built Smart Acharya from the ground up for the privacy and security needs of students, schools and institutions. We do not sell your data, do not use Personal Identifiable Information (PII) to train models, and have world class security and privacy standards. You can find up to date and comprehensive policy documentation on our privacy page."
        },
        {
            question: "Does Smart Acharya offer single sign on (SSO) authentication?",
            answer: "We offer SSO via Google, Meta, etc. This allows our parents and students to share up-to-date student email lists while providing a seamless log in, authentication and verification of identity."
        },
        {
            question: "Can students and educators create their own content on Smart Acharya?",
            answer: "Yes, students and educators can create and upload their own content, including quizzes, lessons, and assignments, to tailor the learning experience for their students."
        },
        {
            question: "Can Smart Acharya integrate with existing Learning Management Systems?",
            answer: "Yes, Smart Acharya can seamlessly integrate with popular Learning Management Systems (LMS) to provide a unified learning experience."
        }
    ];

    const toggleAccordion = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="w-full sm:w-5/6 md:w-3/4 lg:w-4/5 xl:w-4/5 mx-auto py-12 px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
                <h1 className="text-4xl md:text-5xl font-black text-[#5c3e21] mb-4">
                    Frequently Asked Questions
                </h1>
                <p className="text-xl text-gray-700 max-w-2xl mx-auto">
                    Find answers to common questions about Smart Acharya.
                </p>
            </div>

            <div className="bg-white rounded-2xl border border-black shadow-lg w-full min-w-0 overflow-x-hidden">
                <div className="divide-y divide-gray-200">
                    {faqs.map((faq, index) => (
                        <div key={index} className={openIndex === index ? 'bg-gray-50' : ''}>
                            <button
                                onClick={() => toggleAccordion(index)}
                                className="flex justify-between items-center w-full px-6 py-4 text-left focus:outline-none hover:bg-gray-50 transition-colors"
                            >
                                <span className="text-lg font-semibold text-[#5c3e21] pr-4">
                                    {faq.question}
                                </span>
                                <svg
                                    className={`w-5 h-5 text-[#d18b4e] transition-transform duration-200 flex-shrink-0 ${
                                        openIndex === index ? 'rotate-180' : ''
                                    }`}
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M19 9l-7 7-7-7"
                                    />
                                </svg>
                            </button>

                            {openIndex === index && (
                                <div className="px-6 pb-4 pt-0 text-gray-700 leading-relaxed">
                                    <div className="border-t border-gray-200 pt-3 break-words">
                                        <div dangerouslySetInnerHTML={{ __html: faq.answer }} />
                                    </div>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default FAQs;